import fetcher from 'api/fetcher';

export const fetchCancelUpscale = (aiImageQueueId: number): void =>
    void fetcher.put(`/api/v1/images/ai/${aiImageQueueId}/cancel`).catch((error) => {
        console.error(error);
    });
